import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Header } from './components/Header';
import { LoginPage } from './pages/LoginPage';
import { PendingApprovalPage } from './pages/PendingApprovalPage';
import { RejectedPage } from './pages/RejectedPage';
import { HomePage } from './pages/HomePage';
import { NovelListPage } from './pages/NovelListPage';
import { NovelDetailPage } from './pages/NovelDetailPage';
import { ReaderPage } from './pages/ReaderPage';
import { AdminPage } from './pages/AdminPage';
import { AddNovelPage } from './pages/AddNovelPage';
import { AdminNovelUploadPage } from './pages/AdminNovelUploadPage';
import { AuthorPage } from './pages/AuthorPage';
import { SeriesListPage } from './pages/SeriesListPage';
import { SeriesDetailPage } from './pages/SeriesDetailPage';
import { AIConsolePage } from './pages/AIConsolePage';
import { SearchNovelsPage } from './pages/SearchNovelsPage';
import NovelAnalysisPage from './pages/NovelAnalysisPage';
import AnalysisToolConfigPage from './pages/admin/AnalysisToolConfigPage';

// Layout component for protected routes with Header - v2
function ProtectedLayout({ children }: { children: React.ReactNode }) {
  console.debug('[ProtectedLayout] v2');
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="max-w-5xl mx-auto px-4 py-6">{children}</main>
    </div>
  );
}

// Admin route wrapper
function AdminRoute({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute requireAdmin>
      <ProtectedLayout>{children}</ProtectedLayout>
    </ProtectedRoute>
  );
}

// User route wrapper
function UserRoute({ children }: { children: React.ReactNode }) {
  return (
    <ProtectedRoute>
      <ProtectedLayout>{children}</ProtectedLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/pending-approval" element={<PendingApprovalPage />} />
          <Route path="/rejected" element={<RejectedPage />} />

          {/* Reader - protected but special layout (no header) */}
          <Route
            path="/novels/:id/read/:chapterId"
            element={
              <ProtectedRoute>
                <ReaderPage />
              </ProtectedRoute>
            }
          />

          {/* User routes */}
          <Route path="/" element={<UserRoute><HomePage /></UserRoute>} />
          <Route path="/novels" element={<UserRoute><NovelListPage /></UserRoute>} />
          <Route path="/novels/:id" element={<UserRoute><NovelDetailPage /></UserRoute>} />
          <Route path="/novels/:id/analysis" element={<UserRoute><NovelAnalysisPage /></UserRoute>} />
          <Route path="/author/:authorName" element={<UserRoute><AuthorPage /></UserRoute>} />
          <Route path="/series" element={<UserRoute><SeriesListPage /></UserRoute>} />
          <Route path="/series/:id" element={<UserRoute><SeriesDetailPage /></UserRoute>} />

          {/* Admin routes */}
          <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
          <Route path="/admin/add-novel" element={<AdminRoute><AddNovelPage /></AdminRoute>} />
          <Route path="/admin/upload" element={<AdminRoute><AdminNovelUploadPage /></AdminRoute>} />
          <Route path="/admin/ai-console" element={<AdminRoute><AIConsolePage /></AdminRoute>} />
          <Route path="/admin/search" element={<AdminRoute><SearchNovelsPage /></AdminRoute>} />
          <Route path="/admin/analysis-tools" element={<AdminRoute><AnalysisToolConfigPage /></AdminRoute>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
